import { Injectable } from "@angular/core";
import { OccEndpointsService, ProductService } from "@spartacus/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import * as config from '../shared/config/app.config';
import { BaseService } from "../shared/services/base.service";
import { DataLayerService } from "../shared/services/data-layer.service";


@Injectable({
  providedIn: 'root'
})
export class CustomPdpService {
  public productCode = new BehaviorSubject<any>(false);
  productCode$ = this.productCode.asObservable();
  public cartItems = new BehaviorSubject<any>(false);
  cartItems$ = this.cartItems.asObservable();
  public createdCart = new BehaviorSubject<any>(false);
  createdCart$ = this.createdCart.asObservable();
  public cartDetailsUpdate = new BehaviorSubject<any>(false);
  cartDetailsUpdate$ = this.cartDetailsUpdate.asObservable();
  public minicartUpdate = new Subject<any>();
  public relatedProducts = new BehaviorSubject<any>(false);
  relatedProducts$ = this.relatedProducts.asObservable();
  public updateError = new BehaviorSubject<any>(false);
  updateError$ = this.updateError.asObservable();
  baseSite: any;
  itemsArr: any = [];
  constructor(private readonly productSearch: ProductService,
    private readonly baseService: BaseService, private readonly occEndPoint: OccEndpointsService, private _dataService: DataLayerService) {
  }

  public getCategory(): any {
    this.baseSite = this.occEndPoint.getBaseUrl({
      baseUrl: false,
      prefix: false,
      baseSite: true,
    });
  }
  public getPDPCategory(productCode): any {
    this.productCode.next(false);
    this.productSearch.get(productCode).subscribe((res) => {
      if (res) {
        this.productCode.next(res);
      }
    });
  }
  public updateCart(productDetails, userId, cartId, productInfo?, isRelatedProduct?, item?): any {
    this.itemsArr = [];
    this.baseService.post(config.USER_ACCOUNT + userId + '/carts/' + cartId + '/entries?fields=DEFAULT', productDetails).subscribe((res) => {
      /*add to cart DL Push*/
      productDetails.selectedLocations.forEach(el => {
        if (!isRelatedProduct) {
          this._dataService.addtoDataLayer('add_to_cart', productInfo, productDetails, el);
        } else {
          this._dataService.addtoDataLayer('add_to_cart', item, productDetails, el, 'related');
        }
      })
      this._dataService.addtoDataLayer('clearDataLayer', '', '', '');
      /* End of DL push*/

      if (res) {
        this.cartDetailsUpdate.next(true);
        this.minicartUpdate.next(cartId);
      }
    }, (err) => {
      this.updateError.next(err);
    }
    );
  }
  getUpdateMiniCart(): Observable<any> {
    return this.minicartUpdate.asObservable();
  }
  getCarts(userId): void {
    this.baseService.get(config.USER_ACCOUNT + userId + '/carts?currentPage=0&fields=DEFAULT&pageSize=20&savedCartsOnly=false').subscribe((res) => {
      this.cartItems.next(res);
    });
  }
  createCart(userId): void {
    this.baseService.post(config.USER_ACCOUNT + userId + '/carts?fields=DEFAULT', {}).subscribe((res) => {
      this.createdCart.next(res);
    });
  }
  getRelatedProducts(productCode, param): Observable<any> {
    return this.baseService.get(`/products/${productCode}/references`, param);
  }
}